import { useCallback } from 'react';
import { gqlTalentUnionEnum as TALENT_UNION } from '@minecraft.graphql-types';
import { sagAftraOption } from '../config';
import { GetProfileUnionFilterArgs, FilterValues, SelectOption } from '../types';
import { useUnionStatusOptions } from './useUnionStatusOptions';

// Hook wrapper for getProfileUnionFilter helper
export const useProfileUnionFilter = () => {
  const unionStatusOptions = useUnionStatusOptions();

  const getProfileSearchUnionFilterByRoleOptions = useCallback(
    (unionsStatuses: TALENT_UNION[] | readonly TALENT_UNION[]): SelectOption[] => {
      return [...unionStatusOptions, { ...sagAftraOption }].filter((option) => unionsStatuses?.includes(option.value));
    },
    [unionStatusOptions]
  );

  return useCallback(
    ({
      unionStatusName,
      excludeUnionStatusName,
      profileSearchUnionFilterByRole,
    }: GetProfileUnionFilterArgs): FilterValues => {
      return {
        [unionStatusName]: getProfileSearchUnionFilterByRoleOptions(profileSearchUnionFilterByRole.talentUnions),
        [excludeUnionStatusName]: getProfileSearchUnionFilterByRoleOptions(
          profileSearchUnionFilterByRole.excludeTalentUnions
        ),
      };
    },
    [getProfileSearchUnionFilterByRoleOptions]
  );
};
